import React from 'react';
import { AwardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-navy py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-137" data-mp="1j9qpghfdfsh6">
      <div className="mx-auto max-w-3xl px-4" data-id="element-138" data-mp="1na0thojls8te">
        <SectionHeading id="pricing-title" data-id="element-139" data-mp="1s9n9g5qtg35w">Choose Your Option</SectionHeading>

        <article className="mt-10 overflow-hidden rounded-3xl border-2 border-gold bg-panel shadow-2xl shadow-black/50" data-id="element-140" data-mp="1sbq3d0v3agfw">
          <div className="border-b border-electric/30 bg-navy/50 px-6 py-4 sm:px-10" data-id="element-141" data-mp="227jgomgmudyq">
            <span className="inline-flex items-center gap-2 rounded-full border border-electric bg-electric/15 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.14em] text-white" data-id="element-142" data-mp="2up365u27tww">
              <AwardIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-143" data-mp="7vmvhb8sa4c4" /> Main Offer
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-144" data-mp="1hq7zzni7nhwe">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-145" data-mp="1hp6fksfb1j20">
              <div data-id="element-146" data-mp="1crn1ptmir8al">
                <h3 className="text-3xl font-bold leading-tight tracking-tight text-white" data-id="element-147" data-mp="1cr4u60uep7nd">{productShortName}</h3>
                <p className="mt-2 text-sm text-ink" data-id="element-148" data-mp="17pxllzkfw4fn">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-149" data-mp="20gz5gdz2uo5i">
                <span className="text-sm text-ink" data-id="element-150" data-mp="1vgtl7iv503xg">
                  Regular price: <span className="line-through decoration-electric decoration-2" data-id="element-151" data-mp="1vj7epna6582w">{priceBefore}</span>
                </span>
                <p className="mt-2 text-xs font-bold uppercase tracking-[.14em] text-electric" data-id="element-152" data-mp="k1xzxe1zj47x">Today:</p>
                <p className="mt-1 whitespace-nowrap text-6xl font-bold leading-none tracking-tight text-gold" data-id="element-153" data-mp="g02ym9k20qu5">{price}</p>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-154" data-mp="hfothmv17s5r">
              Get my teacher ready now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-ink" data-id="element-155" data-mp="7isj1blkovyk">
              <span className="inline-flex items-center gap-1.5" data-id="element-156" data-mp="cgu1bub6cr8z">
                <LockIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-157" data-mp="3uweg8lx6t1ve" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-158" data-mp="3is4lqyh4kri">
                <ZapIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-159" data-mp="3kz07z9lf3je6" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-160" data-mp="3pymmrngw97p3">
                <ShieldCheckIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-161" data-mp="3bxser5xrd8qy" /> 7-day guarantee
              </span>
            </div>
          </div>
        </article>
      </div>
    </section>;
}